// extracted by mini-css-extract-plugin
module.exports = {"container":"TotalAmount_container__f2bKe","boldText":"TotalAmount_boldText__1xH89"};